import { Link } from "react-router-dom";
import { getBlurbs, getVisibility, listVendors } from "@hub";
import { appUrl } from "../config";
import { useHubVisitor, withVisitor } from "../hubContext";

export default function ClientHub() {
  const visitor = useHubVisitor();
  const visibility = getVisibility();
  const blurbs = getBlurbs();
  if (visibility.clients === false) {
    return (
      <article>
        <h1>Client hub</h1>
        <p className="lead">This hub is hidden for now.</p>
      </article>
    );
  }
  const vendors = listVendors().filter((item) => item.audience === "client");

  return (
    <article>
      <h1>Client hub</h1>
      <p className="lead">{blurbs.clients}</p>
      <div className="card-grid">
        <section className="card">
          <h2>Buyer education</h2>
          <p>Discovery, specs, and lifestyle notes stay on the buyer journey.</p>
          <p>
            <Link to={withVisitor("/support/buyer", visitor)}>Buyer support</Link>
          </p>
        </section>
        <section className="card">
          <h2>Seller education</h2>
          <p>Portfolio, condition, and readiness stay on the seller journey.</p>
          <p>
            <Link to={withVisitor("/support/seller", visitor)}>Seller support</Link>
          </p>
        </section>
        <section className="card">
          <h2>Escrow & closing basics</h2>
          <p>
            <Link to={withVisitor("/vendors/client", visitor)}>Client vendor directory</Link>
          </p>
        </section>
        <section className="card">
          <h2>Open a checklist</h2>
          <p>
            <a href={appUrl("/")}>Start on REChecklist</a>
          </p>
        </section>
      </div>
      <div className="card-grid">
        {vendors.map((item) => (
          <article key={item.id} className="card">
            <p className="muted">{item.group}</p>
            <h3>{item.name}</h3>
            <p>{item.summary}</p>
            <p>
              <Link to={withVisitor(`/vendors/${item.id}`, visitor)}>Vendor detail</Link>
            </p>
          </article>
        ))}
      </div>
    </article>
  );
}
